<template>
<div class="list">
  <div class="breadcrumb">
    <Breadcrumb>
      <Breadcrumb-item>学生管理</Breadcrumb-item>
      <Breadcrumb-item>followUp记录</Breadcrumb-item>
    </Breadcrumb>
  </div>
  <div class="search" @keyup.enter="search">
    <Form :label-width="100" :show-message="false" label-position="right">
      <Row :gutter="32">
        <Col :span="6">
        <Form-item label="课程顾问">
          <Input placeholder="支持模糊搜索" name="userNickname"
                 v-model="queryParam.adviserName" ></Input>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="学导">
          <Input placeholder="支持模糊搜索" name="userNickname"
                 v-model="queryParam.studyNickname" ></Input>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="学生ID" >
          <Input name="uid"
                 v-model="queryParam.uid"></Input>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="学生姓名">
          <Input placeholder="支持模糊搜索" name="userNickname"
                 v-model="queryParam.userNickname"></Input>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="学生手机">
          <Input placeholder="支持模糊搜索" name="userNickname"
                 v-model="queryParam.mobile"></Input>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="状态" prop="traceStatus">
          <Select v-model="queryParam.traceStatus" clearable  @on-change="changeFollow" transfer>
            <Option value="1">高跟进</Option>
            <Option value="2">跟进中</Option>
            <Option value="3">跟进低</Option>
            <Option value="4">无意向</Option>
            <Option value="5">多次联系不到</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="followUp选项" prop="traceItem">
          <Select v-model="queryParam.traceItem" clearable transfer>
            <Option v-for="item in followList"
                    :value="item.id" :key="item.id">{{ item.text }}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="6">
        <FormItem prop="user" label="处理人部门：">
          <Select v-model="queryParam.teamType">
            <Option v-for="item in adviserGroupList" :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </FormItem>
        </Col>
        <Col :span="6">
        <Form-item label="处理人">
          <Input placeholder="支持模糊搜索" name="userNickname"
                 v-model="queryParam.modifierName"></Input>
        </Form-item>
        </Col>
        <Col :span="8" >
        <Form-item label="添加时间">
          <Row>
            <Col span="11">
            <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                         @on-change="startTimeDateChange"
                         v-model="queryParam.startTimeDate" style="width: 100%;"></Date-picker>
            </Col>
            <Col span="2" style="text-align: center">-</Col>
            <Col span="11">
            <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                         @on-change="endTimeDateChange"
                         v-model="queryParam.endTimeDate" style="width: 100%;"></Date-picker>
            </Col>
          </Row>
        </Form-item>
        </Col>
        <Col :span="8" >
        <Form-item label="下次联系时间">
          <Row>
            <Col span="11">
            <DatePicker v-model="snextDate" type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                        @on-change="schangeDate" style="width: 100%;"></DatePicker>
            </Col>
            <Col span="2" style="text-align: center">-</Col>
            <Col span="11">
            <DatePicker v-model="enextDate" type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                        @on-change="echangeDate" style="width: 100%;"></DatePicker>
            </Col>
          </Row>
        </Form-item>
        </Col>
        <Col :span="2">
        <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search" >搜索
        </Button>
        </Col>
      </Row>
    </Form>
  </div>
  <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/saleTrace/list"
        :params="queryParam" :onLoading="onLoading" operator=""></List>
  <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
</div>
</template>
<script>
  import UserInfoModal from '../crm/UserInfoModal.vue'
  export default {
    components: {
      UserInfoModal,
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        showImgModal: false,
        showImgList: [],
        followList: [],
        adviserGroupList: this.$constant.adviserGroup,
        reload: 0,
        snextDate: '',
        enextDate: '',
        editUser: false,
        uid: null,
        queryParam: {
          uid: '',
          mobile: '',
          snextDate: '',
          enextDate: '',
          adviserName: '',
          studyNickname: '',
          traceStatus: '',
          traceItem: '',
          teamType: 0,
          userNickname: '',
          adminNickname: '',
          modifierName: '',
          adminMobile: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          status: null,
          type: '',
          tchId: null,
          subType: null,
          auditorName: ''
        },
        title: [
          {
            title: '学生ID/姓名',
            // width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.userNickname)
            }
          },
          {
            title: '添加时间',
            key: 'gmtCreate',
            // width: 110,
            align: 'center',
          },
          {
            title: '课程顾问',
            key: 'adviserName',
            // width: 110,
            align: 'center',
          },
          {
            title: '学导',
            key: 'studyNickname',
            // width: 120,
            align: 'center',
          },
          {
            title: '状态',
            // width: 120,
            align: 'center',
            render: (h, params) => {
              let type = params.row.traceStatus
              let typeEnum = $constant.getEnum($constant.traceStatus, type)
              return h('div', typeEnum && typeEnum.text)
            }
          },
          {
            title: 'followUp选项',
            // width: 150,
            align: 'center',
            render: (h, params) => {
              let type = params.row.traceItem
              let typeEnum = $constant.getEnum($constant.traceItem, type)
              return h('div', typeEnum && typeEnum.text)
            }
          },
          {
            title: '内容',
            width: 380,
            align: 'center',
            key: 'content'
          },
          {
            title: '下次联系时间',
            // width: 110,
            align: 'center',
            key: 'nextContactTime'
          },
          {
            title: '处理人',
            // width: 120,
            align: 'center',
            key: 'modifierName'
          }
        ]
      }
    },
    mounted: function () {
      let self = this
      let query = self.$route.query
      if (query.startTime) {
        this.queryParam.startTimeDate = parseInt(query.startTime) * 1000
      }
      if (query.endTime) {
        this.queryParam.endTimeDate = parseInt(query.endTime) * 1000
      }
      if (query.snextDate) {
        this.snextDate = query.snextDate
      }
      if (query.enextDate) {
        this.enextDate = query.enextDate
      }
      if (query.teamType) {
        this.queryParam.teamType = parseInt(query.teamType)
      }
      if (query.traceItem) {
        this.queryParam.traceItem = parseInt(query.traceItem)
        let i = parseInt(query.traceStatus)
        if (i === 1) {
          self.followList = [{id: 1, text: '课后-同意购买'}, {id: 2, text: '课后-付款成功，持续跟进'}]
        }
        if (i === 2) {
          self.followList = [{id: 3, text: '课后-讲解产品，学习方案'}]
        }
        if (i === 3) {
          self.followList = [{id: 4, text: '课后-开场'}, {id: 5, text: '课前跟进，确认出席'}, {id: 6, text: '课前跟进，改期'}, {id: 7, text: '课前约课'}]
        }
        if (i === 4) {
          self.followList = [{id: 8, text: '价格问题'}, {id: 9, text: '行业对比'}, {id: 10, text: '不信任'}, {id: 11, text: '级别年龄不符'}]
        }
        if (i === 5) {
          self.followList = [{id: 12, text: '无人接听'}, {id: 13, text: '挂断'}, {id: 14, text: '关机/停机'}, {id: 15, text: '空号'}]
        }
      }
    },
    created: function () {

      let startTime = this.queryParam.startTime
      if (startTime !== '') {
        this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate()
      }
      if (startTime === '') {
        let momentDate = this.$moment().add(-24, 'M')
        momentDate.millisecond(0)
        momentDate.second(0)
        momentDate.minute(0)
        momentDate.hour(0)
        this.queryParam.startTimeDate = momentDate.toDate()
        this.queryParam.startTime = momentDate.format('X')
      }
    },
    methods: {
      viewPic (row) {
        this.showImgList = row.urls
        this.showImgModal = true
      },
      closeImgModal () {
        this.showImgList = []
        this.showImgModal = false
      },
      closeModal (val) {
        this.uid = null
        this.editUser = val
      },
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/FollowUpList'}})
        window.open(href, '_blank')
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },

      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      schangeDate (value) {
        this.queryParam.snextDate = value
      },
      echangeDate (value) {
        this.queryParam.enextDate = value
      },
      changeFollow (val) {
        let self = this
        if (!val) {
          return
        }

        if (val === '1') {
          self.followList = [{id: 1, text: '课后-同意购买'}, {id: 2, text: '课后-付款成功，持续跟进'}]
        }
        if (val === '2') {
          self.followList = [{id: 3, text: '课后-讲解产品，学习方案'}]
        }
        if (val === '3') {
          self.followList = [{id: 4, text: '课后-开场'}, {id: 5, text: '课前跟进，确认出席'}, {id: 6, text: '课前跟进，改期'}, {id: 7, text: '课前约课'}]
        }
        if (val === '4') {
          self.followList = [{id: 8, text: '价格问题'}, {id: 9, text: '行业对比'}, {id: 10, text: '不信任'}, {id: 11, text: '级别年龄不符'}]
        }
        if (val === '5') {
          self.followList = [{id: 12, text: '无人接听'}, {id: 13, text: '挂断'}, {id: 14, text: '关机/停机'}, {id: 15, text: '空号'}]
        }
      },
    }
  }

</script>



// WEBPACK FOOTER //
// FollowUpList.vue?49c8cfb4